import { render, staticRenderFns } from "./TableStaffEditComponent.vue?vue&type=template&id=4d7d3d21"
import script from "./TableStaffEditComponent.vue?vue&type=script&lang=js"
export * from "./TableStaffEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports